import { cn } from "@workspace/ui/lib/utils";
import type { ComponentProps } from "react";

export function GlassPanel({ className, ...props }: ComponentProps<"section">) {
	return (
		<section
			className={cn(
				"glass-highlight rounded-2xl border bg-card/80 backdrop-blur-xl",
				className,
			)}
			{...props}
		/>
	);
}
